// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3M3lC","header":"Messages_header__8QKER"};